import React from "react"
import { Reviews } from "./Reviews"
import { Spinner } from "packages/ui-shared/components/Spinner/Spinner"
import * as styles from "./Reviews.css"

const isProduction = ["production", "test"].includes(
  process.env.NODE_ENV as string
)

export const ReviewsLayout: React.FC<{ sku?: string }> = ({ sku }) => {
  if (!isProduction || !sku) {
    return <></>
  }

  return (
    <Reviews sku={sku}>
      <div className={styles.spinnerWrapper}>
        <Spinner spinnerText="Loading Reviews ..." />
      </div>
    </Reviews>
  )
}
